import { PAGES_TYPES } from 'constants/pagesTypes';

import { consultingPropsData } from './consultingData';
import { cloudMigrationPropsData } from './cloudMigrationData';

export const stepsCardsSliderPropsSelector = {
  [PAGES_TYPES.consulting]: { cardsData: consultingPropsData },
  [PAGES_TYPES.cloudMigration]: { cardsData: cloudMigrationPropsData },
};
